// Resolves the <img> src for an asset preview at the requested derivative size.
// Large still previews can use the permitted 640px image before the 300px grid.
// Video and audio small_url values are media files, so keep their grid-first fallback.
export const resolveAssetImageSrc = (asset, thumbType) => {
    if(asset.type === 'Video' && thumbType === 'permalink') thumbType = 'permalink_image'
    return asset[`${thumbType}_url`] ||
        (thumbType === 'permalink' && asset.type === 'Image' && asset.small_url) ||
        asset.grid_url || asset.small_url
}
